import React, { CSSProperties, PropsWithChildren, useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { translate } from 'loankeeper-common/helpers'
import { LKButton } from './LKButton'
import LKModal, { actions as LKModalActions } from './LKModal'
import { AppDispatch, Extra, ThunkApi } from 'src/store/index.d'
import { AnyAction, AsyncThunk, AsyncThunkAction, ThunkAction } from '@reduxjs/toolkit'
import { RootState } from 'src/store/root.reducer'

const translateLKMessage = (key: string) => translate(`LKMESSAGE-${key}`)

type LKFetcherButtonProps = PropsWithChildren<{
  alias: string
  actionName: string
  buttonAction: AsyncThunk<unknown, any, ThunkApi>
  params: Record<string, any>
  style?: CSSProperties
  disabled?: boolean
  permission?: string | string[]
  message?: string
  successCallbackActions?: ThunkAction<any, RootState, Extra, AnyAction>[]
}>

const LKFetcherButton = (props: LKFetcherButtonProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const {
    actionName,
    message,
    buttonAction,
    successCallbackActions,
    children,
    disabled,
    style,
    alias,
    permission,
    params,
  } = props
  const [loading, setLoading] = useState(false)

  const handleModalOpen = useCallback(() => {
    dispatch(
      LKModalActions.openConfirmation(actionName, {
        message: message || translate('LKMESSAGE-MSG_ARE_YOU_SURE'),
      }),
    )
  }, [])

  const handleConfirm = async () => {
    try {
      setLoading(true)
      const response = await dispatch(buttonAction(params))

      if (!buttonAction.fulfilled.match(response)) {
        throw new Error(response.payload as string)
      }
      if (successCallbackActions) {
        successCallbackActions.forEach((action) => dispatch(action))
      }
    } catch (error) {
      dispatch(LKModalActions.openInfo(translateLKMessage(error.message)))
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {/* @ts-ignore */}
      <LKModal.Confirmation name={actionName} loading={loading} onConfirm={handleConfirm} />
      <LKButton disabled={disabled} style={style} onClick={handleModalOpen} alias={alias} permission={permission}>
        {children}
      </LKButton>
    </>
  )
}

export default LKFetcherButton
